<template>
    <div class="Profile">
        <navigation-bar Close/>
        <div class="main">
            <custom-card class="user-block">
                <div class="avatar" @click="switchImage">
                    <div class="image_empty"  v-if="form.avatar===''"/>
                    <el-image :src="form.avatar" fit="cover" v-else lazy/>
                    <img class="camera" src="@/assets/images/camera.svg">
                </div>
            </custom-card>
            <custom-card>
                <el-row type="flex" justify="end">
                    <el-col :span="4" class="text-right">
                        <el-button type="text" class="edit-btn">
                            <img src="@/assets/images/edit-profile.svg">
                        </el-button>
                    </el-col>
                </el-row>
                <border-input labelText="姓名">
                    <img slot="icon" src="@/assets/images/profile/name.svg">
                    <template slot="input">
                        <OpenEyes :value="form.name" :disabled="nameUnchangeable" :placeholder="'請輸入姓名'"/>
                    </template>
                </border-input>
                <border-input labelText="暱稱">
                    <img slot="icon" src="@/assets/images/profile/nickname.svg">
                    <template slot="input">
                        <input v-model="form.nickname" class="input" :class="required(formType.NICKNAME)" placeholder="請輸入暱稱" maxlength="50">
                        <span class="hint">{{warningText.nickname}}</span>
                    </template>
                </border-input>
                <border-input labelText="手機">
                    <img slot="icon" src="@/assets/images/profile/phone.svg">
                    <template slot="input">
                        <OpenEyes :value="form.phone" :disabled="phoneUnchangeable" :placeholder="'請輸入手機'"/>
                    </template>
                </border-input>
                <border-input labelText="生日">
                    <img slot="icon" src="@/assets/images/profile/birth.svg">
                    <template slot="input">
                        <OpenEyes :value="form.birth" :disabled="birthdayUnchangeable" :placeholder="'請輸入生日'"/>
                    </template>
                </border-input>
                <border-input labelText="性別">
                    <img slot="icon" src="@/assets/images/profile/name.svg">
                    <template slot="input">
                        <el-radio :disabled="genderUnchangeable" v-model="form.gender" label="男">男</el-radio>
                        <el-radio :disabled="genderUnchangeable" v-model="form.gender" label="女">女</el-radio>
                        <el-radio :disabled="genderUnchangeable" v-model="form.gender" label="？">？</el-radio>
                    </template>
                </border-input>
                <border-input labelText="信箱">
                    <img slot="icon" src="@/assets/images/profile/email.svg">
                    <template slot="input">
                        <el-input v-model="form.email" class="input" :class="required(formType.EMAIL)" maxlength="70"
                                  show-password v-if="os==='Android'"/>
                        <OpenEyes :value="form.email" :class="required(formType.EMAIL)" :name="'email'" :type="'url'" :placeholder="' '"
                                  :maxlength="70" @onChange="valueChange" v-else/>
                        <span class="hint email">{{warningText.email}}</span>
                    </template>
                </border-input>
                <border-input labelText="城市">
                    <img slot="icon" src="@/assets/images/profile/house.svg">
                    <template slot="input">
                        <input v-model="form.city" class="input" :class="required(formType.CITY)" placeholder="請輸入縣市" maxlength="250">
                        <span class="hint">{{warningText.city}}</span>
                    </template>
                </border-input>
                <border-input labelText="鄉鎮市區">
                    <template slot="input">
                        <input v-model="form.town" class="input" :class="required(formType.TOWN)" placeholder="請輸入鄉鎮市區" maxlength="250">
                        <span class="hint">{{warningText.town}}</span>
                    </template>
                </border-input>
                <border-input labelText="地址">
                    <template slot="input">
                        <input v-model="form.address" class="input" :class="required(formType.ADDRESS)" placeholder="請輸入地址" maxlength="250">
                        <span class="hint">{{warningText.address}}</span>
                    </template>
                </border-input>
                <div class="footer-button">
                    <el-button @click="goBack()" round>取消</el-button>
                    <el-button @click="onClickSubmit" type="primary" round>送出</el-button>
                </div>
            </custom-card>
            <comm-dialog :value="dialog.isShowDialog" :outerContent="dialog.dialogMsg"  :isCancel="dialog.cancelable" @result="onCommDialogClose"/>
            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true">
            </loading>
            <toast/>
        </div>
    </div>

</template>

<script>
    import CustomCard from '@/components/CustomCard.vue';
    import BorderInput from '@/components/BorderInput.vue';
    import CommDialog from '@/components/CommDialog.vue';
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import {getFileExtension, notNull} from '@/util/common';
    import {getCryptoUserInfo, getCryptoUserPhone, saveCryptoUserInfo} from "@/util/cryptoLocalStorage";
    import {checkSpecialChars, checkDoubleDots, checkValidEmail, checkAddress} from "@/util/validators";
    import OpenEyes from "@/components/OpenEyes";

    export default {
        name: "App",
        components: {CustomCard, BorderInput, Toast, CommDialog , OpenEyes},
        data() {
            return {
                isLoading: false,
                form: {
                    avatar: '',
                    name: '',
                    nickname: '',
                    phone: '',
                    birth: '',
                    gender: '',
                    email: '',
                    city: '',
                    town: '',
                    address: '',
                    genderIndex: 0
                },
                nameUnchangeable: true,       //姓名是否不可改？ true:不可改
                genderUnchangeable: true,       //性別是否不可改？
                birthdayUnchangeable: true,       //生日是否不可改？
                phoneUnchangeable: true,            //電話是否不可改？
                dialog: {
                    isShowDialog: false,
                    dialogMsg: '',
                    cancelable: false,
                },
                functionAfterDialog: [],            //Notice Dialog關閉後要做的事
                formType: {
                    NICKNAME: 0, EMAIL: 1, CITY: 2, TOWN: 3, ADDRESS: 4
                },
                warningText: {
                    nickname: '', email: '', city: '', town: '', address: ''
                },
                os: this.$http.getOS(),
            }
        },
        created() {

        },
        mounted() {
            this.refreshUserData();

            let self = this;
            //監聽截圖事件
            document.addEventListener("onTookScreenshot",function(){
                // Receive notification when screenshot is ready;
                self.showDialog("注意!!\n" +
                    "您現在截圖之訊息可能含有敏感資訊，請勿分享給他人造成資訊外洩", false);
            });
        },
        computed:{
            required(){
                return type => {
                    switch (type) {
                        case this.formType.NICKNAME:
                            if (this.form.nickname === '') {
                                this.warningText.nickname = '';
                                return '';
                            } else if (checkSpecialChars(this.form.nickname)) {
                                this.warningText.nickname = '暱稱不得含有<>/;*\\等特殊字元';
                                return 'required';
                            } else if (checkDoubleDots(this.form.nickname)) {
                                this.warningText.nickname = '暱稱不得含有連續的點(.)';
                                return 'required';
                            } else {
                                this.warningText.nickname = '';
                                return '';
                            }
                        case this.formType.EMAIL:
                            if (this.form.email === '') {
                                this.warningText.email = '';
                                return '';
                            } else if (!checkValidEmail(this.form.email)) {
                                this.warningText.email = '請輸入正確的信箱';
                                return 'required';
                            } else {
                                this.warningText.email = '';
                                return '';
                            }
                        case this.formType.CITY:
                            if (this.form.city === '') {
                                this.warningText.city = '';
                                return '';
                            } else if (!checkAddress(this.form.city)) {
                                this.warningText.city = '請輸入正確的城市';
                                return 'required';
                            } else {
                                this.warningText.city = '';
                                return '';
                            }
                        case this.formType.TOWN:
                            if (this.form.town === '') {
                                this.warningText.town = '';
                                return '';
                            } else if (!checkAddress(this.form.town)) {
                                this.warningText.town = '請輸入正確的鄉鎮市區';
                                return 'required';
                            } else {
                                this.warningText.town = '';
                                return '';
                            }
                        case this.formType.ADDRESS:
                            if (this.form.address === '') {
                                this.warningText.address = '';
                                return '';
                            } else if (!checkAddress(this.form.address)) {
                                this.warningText.address = '請輸入正確的地址';
                                return 'required';
                            } else {
                                this.warningText.address = '';
                                return '';
                            }
                    }
                }
            },
        },
        methods: {

            /** 顯示訊息 dialog */
            showDialog: function (msg, cancelable = false, nextMove = '') {
                this.dialog.cancelable = cancelable;
                this.dialog.dialogMsg = msg;
                this.dialog.isShowDialog = true;
                if (nextMove !== '') {
                    this.functionAfterDialog = [nextMove];
                } else {
                    this.functionAfterDialog = [""];
                }

            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                this.dialog.isShowDialog = false;
                this[this.functionAfterDialog[0]]();
                // this.goBack();
            },

            /** 更新個人資料 */
            refreshUserData: function () {
                // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                const userData = getCryptoUserInfo();
                this.form.avatar = userData.picture
                this.form.name = userData.name
                this.form.nickname = userData.nickName
                // this.form.phone = localStorage.getItem('phone') || ""
                this.form.phone = getCryptoUserPhone();
                this.form.birth = userData.birthdayAt
                this.form.genderIndex = userData.gender
                switch (userData.gender) {
                    case 0:
                        this.form.gender = '?'
                        break
                    case 1:
                        this.form.gender = '男'
                        break
                    case 2:
                        this.form.gender = '女'
                        break
                }
                this.form.email = userData.email
                this.form.city = userData.city
                this.form.town = userData.township
                this.form.address = userData.address

                // 欄位鎖定
                this.nameUnchangeable = (userData.name !== '');
                this.birthdayUnchangeable = (userData.birth !== '');
                this.genderUnchangeable = (userData.gender !== 0);
            },

            /** 按下送出按鍵 */
            onClickSubmit: function () {
                let self = this;

                self.$el.style.setProperty('--borderColor333', `${"#EA4E5E"}`);
                self.$el.style.setProperty('--hintDisplay', `${"block"}`);
                const required = document.getElementsByClassName('required').length;
                if (required !== 0) {
                    return;
                }

                self.isLoading = true;
                self.updateUserInfo()
                    .then( self.getUserInfo )
                    .then( () => {
                        self.isLoading = false;
                        // self.saveUserData(data);
                        self.showDialog('個人資訊更新成功', false, "goBack");

                    })
                    .catch( (error) => {
                        self.isLoading = false;
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            },

            /** cordova 選取照片 */
            cordovaImagePicker: function () {
                // let self = this;
                let isCordova = !!window.cordova;
                if(isCordova){

                    // window.AdvancedImagePicker.present({
                    //     // config here
                    //     min: Number(1),
                    //     minCountMessage: '最少要選取一張照片',
                    //     max: Number(1),
                    //     maxCountMessage: '最多選取一張照片',
                    //
                    // }, function(success) {
                    //     if (success !== null && success.length > 0) {
                    //         if (success[0].src !== null && success[0].src !== '') {
                    //             self.onSuccess(success[0].src);
                    //         }
                    //     } else {
                    //         alert('');
                    //     }
                    //
                    // }, function (error) {
                    //     console.error(JSON.stringify(error));
                    //     self.onFail(error);
                    //
                    // });

                }
            },
            /** 開啓圖片選取器 */
            switchImage: function () {
                let isCordova = !!window.cordova;
                if(isCordova) {
                    // this.cordovaImagePicker();
                } else {
                    //cordova-plugin-camera使用的照片選取段落，當做 web 取用相片
                    this.capturePhoto();
                }

            },
            capturePhoto: function () {
                navigator.camera.getPicture(this.onSuccess, this.onFail, {
                    //拍照
                    quality: 50,
                    correctOrientation: true,
                    // eslint-disable-next-line no-undef
                    destinationType: Camera.DestinationType.FILE_URL,
                });
                this.dialogVisible = false
            },
            getPhoto: function () {
                navigator.camera.getPicture(this.onSuccess, this.onFail, {
                    quality: 50,
                    // eslint-disable-next-line no-undef
                    destinationType: Camera.DestinationType.FILE_URL,
                    // eslint-disable-next-line no-undef
                    sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM
                });
            },

            /** 取得檔案 */
            onSuccess: function (imageData) {
                // eslint-disable-next-line no-undef
                let ft = new FileTransfer();
                // eslint-disable-next-line no-undef
                let options = new FileUploadOptions();

                //判斷副檔名來改變上傳的檔案類型，FileUploadOptions 預設檔名是 image.jpg，若內容與檔名的格式不符會出現錯誤
                let extFilename = getFileExtension(imageData);
                if(extFilename === 'png'){
                    options.fileName = 'image.png';
                }

                let params = {
                    "folder": "/headerPhoto",
                    "apiKey": "41e1ac4a1ad16b11275cd9121b572225"
                }
                options.params = params

                this.isLoading = true;
                let serverUrl = process.env.VUE_APP_FILE_HOST + '/api'
                ft.upload(imageData, serverUrl, this.uploadCompleted, this.uploadedFail, options)
            },
            /** 檔案選取失敗 */
            onFail: function (message) {
                console.log(message)
            },
            /** 檔案上傳成功 */
            uploadCompleted: function (r) {

                this.isLoading = false;

                if (JSON.parse(r.response).status) {
                    const url = JSON.parse(r.response).data[0]
                    const imgUrl = process.env.VUE_APP_FILE_HOST + '/' + url
                    this.form.avatar = imgUrl
                    this.updateAvatar(url)
                }
            },
            /** 檔案上傳失敗 */
            uploadedFail: function (error) {
                this.isLoading = false;

                alert("An error has occurred: Code = " + error.code);
            },

            /** 更新個人資料 */
            updateUserInfo: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    switch (self.form.gender) {
                        case "?":
                            self.form.genderIndex = 0
                            break
                        case '男':
                            self.form.genderIndex = 1
                            break
                        case '女':
                            self.form.genderIndex = 2
                            break
                    }

                    self.isLoading = true;

                    self.$http.fetchWithAuth`UpdateUserInfo${{
                        'name': self.form.name,
                        'nickName': self.form.nickname,
                        'birthdayAt': self.form.birth,
                        'gender': self.form.genderIndex,
                        'email': self.form.email,
                        'city': self.form.city,
                        'township': self.form.town,
                        'address': self.form.address,
                    }} ${json => {
                        self.isLoading = false;

                        if (json.status === true) {
                            //成功
                            resolve();
                        } else {
                            reject(json.message);
                        }
                    }}`;
                });
            },

            /** 取得個人資料 */
            getUserInfo: function () {
                this.isLoading = true;

                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`GetUserInfoWithId${{

                    }} ${json => {
                        self.isLoading = false;

                        if (notNull(json.data)) {
                            resolve(json.data);
                        } else {
                            reject(json.message);
                        }
                    }}`;
                });
            },

            /** 更新大頭圖 */
            updateAvatar: function (imageUrl) {
                this.isLoading = true;
                this.$http.fetchWithAuth`UpdateUserPicture${{
                    'picture': imageUrl,
                }}
                ${json => {
                    this.isLoading = false;
                    alert(json.message)
                }}`;
            },

            /** 回上一頁 */
            goBack: function () {
                this.$router.go(-1)
            },
            valueChange(name,val){
                if (name==='email'){
                    this.form.email =val
                }
            },
        }
    }
</script>
<style lang="less" scoped src="../../../less/personalInfo.less"/>
<style lang="less" scoped>
    /deep/.d-flex{
        position: relative;
    }
    .hint{
        position: absolute;
        left: 16.66667%;
        top: 50px;
    }
    input:not(.input){
        .hint.email{
            left: 0;
            top: 20px;
        }
    }
</style>